import type {
  AccountSettingsPatchApiData,
  AccountSettingsPatchApiResponses,
  WhatsNewSeenGetApiData,
  WhatsNewSeenGetApiResponses,
  WhatsNewSeenMarkApiData,
  WhatsNewSeenMarkApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const accountMeUrls = {
  patchAccountSettings: responseEndpoint<AccountSettingsPatchApiData, AccountSettingsPatchApiResponses>({
    getUrl: () => apiUrl('accounts/me/settings/'),
    getBody: (data) => data
  }),
  getWhatsNewSeen: dataEndpoint<WhatsNewSeenGetApiData, WhatsNewSeenGetApiResponses>({
    getUrl: ({ app }) => apiUrl('accounts/me/whats-new-seen/', { app })
  }),
  postWhatsNewSeen: responseEndpoint<WhatsNewSeenMarkApiData, WhatsNewSeenMarkApiResponses>({
    getUrl: () => apiUrl('accounts/me/whats-new-seen/'),
    getBody: (data) => data
  })
};
